import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePriceRatesQuery = createQueryHook(MembershipsCreatorV2ApiClient.getPriceRates, {
  queryKey: ['priceRates'],
})
